import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e6eb8cd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "counter"
};
const _hoisted_2 = { class: "details" };
const _hoisted_3 = { class: "recipient-status" };
const _hoisted_4 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedStatusBadge = _resolveComponent("FriedStatusBadge");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_FriedH4 = _resolveComponent("FriedH4");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedButton = _resolveComponent("FriedButton");
    const _component_FriedCard = _resolveComponent("FriedCard");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createBlock(_component_FriedCard, { class: "signer-container" }, {
        default: _withCtx(() => [
            _createElementVNode("div", {
                class: _normalizeClass(['names', _ctx.blockWidthClass])
            }, [
                (_ctx.isSigningOrder)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.orderNum), 1))
                    : _createCommentVNode("", true),
                (_ctx.isBlockWidthSmall(_ctx.blockWidthClass))
                    ? (_openBlock(), _createBlock(_component_FriedStatusBadge, {
                        key: 1,
                        text: _ctx.statusBadgeContent.text,
                        "status-type": _ctx.statusBadgeContent.statusType,
                        border: _ctx.statusBadgeContent.border
                    }, null, 8, ["text", "status-type", "border"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_FriedParagraph, {
                        class: "text-gray",
                        size: _ctx.ParagraphSize.Small
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.role), 1)
                        ]),
                        _: 1
                    }, 8, ["size"]),
                    _createElementVNode("div", {
                        class: _normalizeClass(['name-title', _ctx.blockWidthClass])
                    }, [
                        _createVNode(_component_FriedH4, null, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.fullName), 1)
                            ]),
                            _: 1
                        }),
                        (_ctx.contractDisplaySettings.title)
                            ? (_openBlock(), _createBlock(_component_FriedParagraph, {
                                key: 0,
                                class: "text-gray"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formattedTitle), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.contractDisplaySettings.company && _ctx.companyName)
                        ? (_openBlock(), _createBlock(_component_FriedParagraph, { key: 0 }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.companyName), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.contractDisplaySettings.email && _ctx.email)
                        ? (_openBlock(), _createBlock(_component_FriedParagraph, {
                            key: 1,
                            size: _ctx.ParagraphSize.Small,
                            class: "email"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.email), 1)
                            ]),
                            _: 1
                        }, 8, ["size"]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (!_ctx.isBlockWidthSmall(_ctx.blockWidthClass))
                        ? (_openBlock(), _createBlock(_component_FriedStatusBadge, {
                            key: 0,
                            text: _ctx.statusBadgeContent.text,
                            "status-type": _ctx.statusBadgeContent.statusType,
                            border: _ctx.statusBadgeContent.border
                        }, null, 8, ["text", "status-type", "border"]))
                        : _createCommentVNode("", true),
                    (_ctx.signingPageUrl)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_FriedButton, {
                                target: "_blank",
                                "data-external": "editor-view-contract-link-signing-page-url",
                                disabled: _ctx.isSigningPageUrlDisabled,
                                onClick: _ctx.handleClick
                            }, {
                                leftIcon: _withCtx(() => [
                                    _createVNode(_component_FriedIcon, { icon: "share" })
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('review_contract')), 1)
                                ]),
                                _: 1
                            }, 8, ["disabled", "onClick"])
                        ])), [
                            [_directive_tooltip, Object.assign(Object.assign({}, _ctx.toolTipOptions), { placement: _ctx.TooltipPlacement.Top, content: _ctx.getTooltip })]
                        ])
                        : _createCommentVNode("", true)
                ])
            ], 2)
        ]),
        _: 1
    }));
}
